import React from 'react';

export const Repeat: React.FC<{ times: number }> = ({ times, children }) => (
  <>{React.Children.toArray(Array(times).fill(children))}</>
);
